class VariantSelector extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.wrapper = this.closest('product-form-component');
    if (this.closest('product-info')) {
      this.wrapper = this.closest('product-info');
    }

    this.options = {
      isQuickShop: false,
    };

    // Get options from element data and combine with this.options
    if (this?.dataset?.options) {
      const dataOptions = JSON.parse(this.dataset.options);
      this.options = {
        ...this.options,
        ...dataOptions,
      };
    }

    if (this.options.type === 'radios') {
      this.selectors = this.querySelectorAll('input[type="radio"]');
    }
    else if (this.options.type === 'selects') {
      this.selectors = this.querySelectorAll('select');
    }

    this.onVariantChange = this.onVariantChange.bind(this);
    this.selectors.forEach(selector => {
      selector.addEventListener('change', this.onVariantChange);
    });
  }

  disconnectedCallback() {
    this.selectors.forEach(selector => {
      selector.removeEventListener('change', this.onVariantChange);
    });
  }

  onVariantChange(event) {
    this.variantId = event.target.value;

    if (this.options.isQuickShop) {
      this.fetchProductInfo();
    }
    else {
      this.fetchSectionData();
    }
  }

  fetchProductInfo() {
    const url = `${this.options.url}?variant=${this.variantId}&view=${this.options.section}`;

    fetch(url)
      .then(response => {
        return response.text();
      })
      .then(data => {
        const html = new DOMParser().parseFromString(data, 'text/html');

        const productInfo = document.querySelector('[data-product-info]');
        if (html.querySelector('[data-product-info]')) {
          productInfo.innerHTML = html.querySelector('[data-product-info]').innerHTML;
        }
      })
      .catch(error => {
        if (error.name !== 'AbortError') {
          console.error('Error fetching product info:', error);
        }
      });
  }

  fetchSectionData() {
    const url = `${this.options.url}?variant=${this.variantId}&section_id=${this.options.section}`;

    fetch(url)
      .then(response => {
        return response.text();
      })
      .then(data => {
        const html = new DOMParser().parseFromString(data, 'text/html');

        document.querySelector('[data-product-info]').innerHTML =
          html.querySelector('[data-product-info]')?.innerHTML;
        document.querySelector('[data-product-media]').innerHTML =
          html.querySelector('[data-product-media]')?.innerHTML;

        this.variantInventoryQuantity = html.querySelector('[data-product-info]').dataset.productInventoryQuantity;
        this.variantPrice = html.querySelector('[data-price]')?.innerHTML;
        if (this.variantPrice && document.querySelector('[data-add-to-cart-price]')) {
          document.querySelector('[data-add-to-cart-price]').innerHTML = this.variantPrice;
        }

        this.updateURL(url);
        this.dispatchVariantChange();
      })
      .catch(error => {
        if (error.name !== 'AbortError') {
          console.error('Error fetching variant:', error);
        }
      });
  }

  updateURL(url) {
    const newUrl = new URL(url, window.location.origin);
    newUrl.searchParams.delete('section_id');
    window.history.pushState({}, '', newUrl.toString());
  }

  dispatchVariantChange() {
    document.dispatchEvent(new CustomEvent('variant-change', {
      bubbles: true,
      detail: {
        variant: this.variantId,
        inventoryQuantity: this.variantInventoryQuantity,
      },
    }));
  }
}

if (!customElements.get('variant-selector')) {
  customElements.define('variant-selector', VariantSelector);
}